var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"facebookLoginButton",attrs:{"disabled":!_vm.canGo},on:{"click":_vm.loginWithFacebook}},[_c('i'),_vm._v(" "+_vm._s(_vm.$t('Continue with Facebook'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }